<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{$t("qrc.historyTitle")}}
      </div>
      <div class="btn-group pull-right">
        <el-button :plain="true" size="mini" @click="goBack">{{ $t("back") }}
          <i class="fa el-icon-back"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">
      <el-table border stripe :data="historyRecords" size="mini" class="customer-table">
        <el-table-column label="操作" align="center" :resizable="true" v-if="canExport">
          <template slot-scope="scope">
            <el-button @click="exportCodes(scope.row.BatchNumber)" type="text" size="small">{{$t("qrc.exportCodes")}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="BatchNumber" align="center" :resizable="true" :label="this.$t('qrc.batchNumber')">
        </el-table-column>
        <el-table-column prop="GenerateCount" align="center" :resizable="true" :label="this.$t('qrc.count')">
        </el-table-column>
        <el-table-column prop="GenerateTime" align="center" :resizable="true" :label="this.$t('qrc.generateTime')" :formatter="timeFormatter">
        </el-table-column>
        <el-table-column prop="UserName" align="center" :resizable="true" :label="this.$t('qrc.generatePerson')">
        </el-table-column>
      </el-table>

      <el-row class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>

      <!-- search dialog -->
      <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible" width="40%">
        <el-form class="search-form" :model="filter" :inline="true" size="small" label-width="70px">
          <el-form-item :label="this.$t('qrc.batchNumber')" size="small">
            <el-input v-model="filter.BatchNumber"></el-input>
          </el-form-item>
          <el-form-item :label="this.$t('qrc.generatePerson')" size="small">
            <el-input v-model="filter.UserName"></el-input>
          </el-form-item>
          <el-form-item :label="this.$t('qrc.generateTime')" size="small">
            <el-date-picker v-model="filter.StartGenTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="this.$t('to')" size="small">
            <el-date-picker v-model="filter.EndGenTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-form>

        <div slot="footer" class="search-footer">
          <el-button @click="searchDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
          <el-button @click="resetFilter" :plain="true" size="mini">{{this.$t('reset')}}</el-button>
          <el-button type="primary" @click="search" :plain="true" size="mini">{{this.$t('confirm')}}</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";
import fileSaver from "file-saver";
import { mapGetters } from "vuex";
export default {
  name: "QRCCode",
  data() {
    var checkBatchNumber = (r, v, callback) => {
      if (v) {
        this.$axios.get(`api/qrc/existBatchNumber/${v}`).then(resp => {
          if (resp.data) {
            callback();
          } else {
            callback(new Error(this.$t("qrc.batchNumberNotExist")));
          }
        });
      }
    };

    return {
      searchDialogVisible: false,
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      historyRecords: [],
      filter: {
        BatchNumber: "",
        UserName: "",
        StartGenTime: "",
        EndGenTime: ""
      },
      filterOptions: []
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getHistory();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getHistory();
    },
    getHistory() {
      this.loading = true;
      let params = {
        filter: JSON.stringify(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios
        .get("api/qrc/history", { params })
        .then(res => {
          this.totalCount = res.data.TotalCount;
          this.historyRecords = res.data.Data;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    search() {
      this.searchDialogVisible = false;
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
      searchHistoryService.setHistory(
        searchTypes.QRCHISTORY_HISTORY,
        this.filterOptions
      );
      this.getHistory();
    },
    resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.QRCHISTORY_HISTORY);
    },
    refresh() {
      this.resetFilter();
      this.getHistory();
    },
    initializeFilter() {
      let his = searchHistoryService.getHistory(searchTypes.QRCHISTORY_HISTORY);
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
      }
    },
    exportCodes(batchNumber) {
      this.$axios
        .get(`api/qrc/export/${batchNumber}`)
        .then(resp => {
          let fileName = decodeURIComponent(
            resp.headers["file-name"] || "二维码.csv"
          );
          const BOM = "\ufeff";
          let blob = new Blob([BOM + resp.data]);
          fileSaver.saveAs(blob, fileName);
        });
    },
    goBack() {
      this.$router.push({ name: "QRCCode" });
    }
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    canExport() {
      return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(p => p.toLowerCase() === "qrc.export")
      );
    }
  },
  created() {
    this.initializeFilter();
    searchHistoryService.removeBesides(searchTypes.QRCHISTORY_HISTORY);
    this.getHistory();
  }
};
</script>









// WEBPACK FOOTER //
// src/components/application/QRC/QRCHistory.vue